const account = {
  state: {
    status: 0 //0未登录，1已登录
  },
  mutations: {
    SET_STATUS: (state, data) => {
      state.status = data
    }
  },
  actions: {
    setStatus({ commit }, data) {
      return new Promise(resolve => {
        commit('SET_STATUS', data)
        resolve()
      })
    }
  }
}

export default account



// WEBPACK FOOTER //
// ./src/store/modules/account.js